function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.8 0L0 14.8V19.5167L19.5167 0H14.8ZM27.5167 0.133386L0.133386 27.5167C0.283386 28.0834 0.583386 28.6001 0.983386 29.0167C1.40005 29.4167 1.91672 29.7167 2.48339 29.8667L29.8834 2.48339C29.5667 1.33339 28.6667 0.433386 27.5167 0.133386ZM0 3.33333C0 1.5 1.5 0 3.33333 0H6.66667L0 6.66667V3.33333ZM26.6667 30C27.5833 30 28.4167 29.6333 29.0167 29.0167C29.6333 28.4167 30 27.5833 30 26.6667V23.3333L23.3333 30H26.6667ZM15.2 30H10.4834L30 10.4834V15.2L15.2 30Z"
});

const SvgMaps = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgMaps, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Maps.5e2dd5a4.svg";
export { ForwardRef as ReactComponent };